export default class Auxiliary {
    static isValidUrl(url: string) : boolean {
        return /^https?:\/\/[^\s/$.?#].[^\s]*$/i.test(url);
    }
}